import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useGetIdentity } from "ra-core";
import { fetchMyExtension, phoneEnabled } from "./phoneApi";

export const MY_EXTENSION_KEY = "phone.myExtension";

/** The signed-in user's phone extension (from the `extensions` table), or null when none is set. */
export function useMyExtension(): {
  extension: string | null;
  salesId: number | null;
  isLoading: boolean;
  refresh: () => void;
} {
  const { identity } = useGetIdentity();
  const salesId = identity?.id != null ? Number(identity.id) : null;
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: [MY_EXTENSION_KEY, salesId],
    queryFn: () => fetchMyExtension(salesId as number),
    enabled: phoneEnabled && salesId != null,
    staleTime: 5 * 60 * 1000,
  });
  return {
    extension: data ?? null,
    salesId,
    isLoading,
    refresh: () => {
      void queryClient.invalidateQueries({
        queryKey: [MY_EXTENSION_KEY, salesId],
      });
    },
  };
}
